import { api } from './';
import {
  ICreateTaskInput,
  IUpdateTaskInput,
  IFilterTask,
  IUpdateChecklistItemsInput,
  ITaskChecklistItem,
} from 'src/interfaces/task';

const TasksService = {
  all: async (filter: IFilterTask) => {
    const { orderBy, orderDirection, sectorId, maintenanceType } = filter;

    const url = `/tasks?orderBy=${orderBy}&orderDirection=${orderDirection}${
      sectorId ? `&sectorId=${sectorId}` : ''
    }${filter.stage !== undefined ? `&stage=${filter.stage}` : ''}${
      maintenanceType !== undefined ? `&maintenanceType=${maintenanceType}` : ''
    }`;

    const res = await api.get(url);

    return res.data;
  },
  fetchTasksByTechnicians: async (filter: IFilterTask) => {
    const res = await api.get(
      `/technicians/tasks?orderBy=${filter.orderBy}&orderDirection=${filter.orderDirection}`
    );

    return res.data;
  },
  current: async (id: string) => {
    const res = await api.get(`/tasks/${id}`);
    return res.data;
  },
  create: async (input: ICreateTaskInput) => {
    const res = await api.post('/tasks', input);
    return res.data;
  },
  update: async (id: string, input: IUpdateTaskInput) => {
    const res = await api.put(`/tasks/${id}`, input);
    return res.data;
  },
  remove: async (id: string) => {
    const res = await api.delete(`/tasks/${id}`);
    return res.data;
  },
  listChecklistItems: async (id: string): Promise<ITaskChecklistItem[]> => {
    const res = await api.get(`/tasks/${id}/checklist-items`);
    return res.data;
  },
  updateChecklistItems: async (
    id: string,
    input: IUpdateChecklistItemsInput
  ): Promise<ITaskChecklistItem[]> => {
    const res = await api.put(`/tasks/${id}/checklist-items`, input);
    return res.data;
  },
};

export default TasksService;
